// extracted by mini-css-extract-plugin
export default {"brand_banner_item":"style_brand_banner_item__OYAk5"};